import React, { useEffect, useState } from 'react';
import './paymentBox.scss';
import PriceItem from '../../atoms/PriceItem/PriceItem';
import BtnStandardIconText from '../../../ds/BtnStandardIconText/BtnStandardIconText';
import CardDetails from '../CardDetails/CardDetails';
import {
  useFileUpload,
  useOrders,
  useUnpaidOrders,
} from '../../../hooks/orders';
import { usePaymentCardsQuery } from '../../../hooks/cards';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import useOrderPrices from '../../../hooks/prices';
import Cookies from 'js-cookie';
import PaymentLoader from '../../../loaders/PaymentLoader';
import { useContent, useLanguages } from '../../../hooks/content';
import { Returntext } from '../../../pages/Landings/common/returnText';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as WarnRecIcon } from '../../../icons/warn-rec.svg';
import PriceItem2 from '../../atoms/PriceItem/PriceItem2';
import PaymentTypeSwitcher from '../PaymentTypeSwitcher/PaymentTypeSwitcher';
import { useDispatch, useSelector } from 'react-redux';
import { setB2BDrawerStep1, setPaymentDrawer } from '../../../redux/actions';

const PaymentBox = ({
  selectedOrders,
  nextClick,
  activeOrder,
  address,
  setActiveOrder,
  cancelClick,
}) => {
  const { lang } = useLanguages();
  const { contentManagementData } = useContent();
  const navigate = useNavigate();
  const { data: paymentCards } = usePaymentCardsQuery();
  const user = JSON.parse(localStorage.getItem('user'));
  const { refetchOrders, orders } = useOrders(
    user.id,
    'RECEIVED_IN_TBILISI_WAREHOUSE',
  );
  const [loading, setLoading] = useState(false);

  const { refetchUnpaidOrders } = useUnpaidOrders(user.id);

  const { handleFileUpload } = useFileUpload();

  const dispatch = useDispatch();

  const [cardInfo, setCardInfo] = useState(
    paymentCards && paymentCards.length > 0
      ? paymentCards.find((card) => card.isDefault)
      : '',
  );
  const userData = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    setCardInfo(
      paymentCards && paymentCards.length > 0
        ? paymentCards.find((card) => card.isDefault)
        : '',
    );
  }, [paymentCards]);

  const access_token = Cookies.get('access_token');

  const { enqueueSnackbar } = useSnackbar();

  const { data, refetchOrderPrices } = useOrderPrices({
    orders: selectedOrders?.map((item) => item.id),
    address_id: address?.id,
  });

  useEffect(() => {
    refetchOrders();
    refetchUnpaidOrders();
    refetchOrderPrices();
  }, [activeOrder]);

  const longPollingFunction = async (duration, count, handleCheckPayment) => {
    let attempts = 0;

    const poll = async () => {
      if (attempts < count) {
        attempts++;
        const transactionResult = await handleCheckPayment();

        if (transactionResult.payStatus === 'COMPLETED') {
          setActiveOrder(transactionResult.orderToUpdate);
          nextClick();
          enqueueSnackbar(
            Returntext(
              contentManagementData,
              'ErrorMessages-paymentsuccess',
              lang,
            ),
            {
              variant: 'success',
            },
          );
          setLoading(false);
          console.log(transactionResult);
          return;
        } else if (transactionResult.payStatus === 'REJECTED') {
          console.log('end');
          setLoading(false);

          enqueueSnackbar(Returntext(contentManagementData, 'pmFail', lang), {
            variant: 'error',
          });
          return;
        } else if (
          transactionResult.payStatus === 'PENDING' &&
          attempts === count
        ) {
          console.log('end');
          cancelClick();
          setLoading(false);
          return;
        } else {
          console.log(transactionResult);
          setTimeout(poll, duration);
        }
      } else {
        console.log('end');
        // cancelClick();
        setLoading(false);

        enqueueSnackbar(Returntext(contentManagementData, 'pmFail', lang), {
          variant: 'error',
        });
        return;
      }
    };

    poll();
  };

  const handleCheckPayment = async () => {
    try {
      const requestBody = {
        address_id: address.id,
      };

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/orders/order_payment_status/${activeOrder.id}?accessToken=${access_token}`,
        requestBody,
      );

      refetchOrderPrices();
      refetchUnpaidOrders();
      refetchOrders();
      return res.data;
    } catch (error) {
      console.log(error);
      return 'server error';
    }
  };

  const handleTransaction = async () => {
    try {
      if (address !== '' && cardInfo !== '') {
        const arrayOfIds = selectedOrders.map((item) => item.id);
        setLoading(true);
        const requestBody = {
          card: cardInfo.id,
          customer_id: user.id,
          order_ids: arrayOfIds,
          address_id: address.id,
        };

        await axios.post(
          `${process.env.REACT_APP_API_URL}/transactions?accessToken=${access_token}`,
          requestBody,
        );

        longPollingFunction(3000, 5, handleCheckPayment);
      } else {
        enqueueSnackbar(
          Returntext(contentManagementData, 'Error_Payemnt123', lang),
          {
            variant: 'error',
          },
        );
        setLoading(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      enqueueSnackbar(
        Returntext(contentManagementData, 'Error_Payemnt123', lang),
        {
          variant: 'error',
        },
      );
      setLoading(false);
    }
  };

  const handleTransactionB2B = async () => {
    try {
      setLoading(true);
      if (address !== '') {
        const arrayOfIds = selectedOrders.map((item) => item.id);
        setLoading(true);
        const requestBody = {
          customer_id: user.id,
          order_ids: arrayOfIds,
          address_id: address.id,
        };
        await axios.post(
          `${process.env.REACT_APP_API_URL}/transactions/pay/invoice?accessToken=${access_token}`,
          requestBody,
        );

        await axios.post(
          `${process.env.REACT_APP_API_URL}/orders/order_payment_status/${activeOrder.id}?accessToken=${access_token}`,
          requestBody,
        );
        await refetchOrders();
        const updatedOrder = orders.find(
          (order) => order.id === activeOrder.id,
        );
        if (updatedOrder) {
          setActiveOrder(updatedOrder);
        }
        refetchUnpaidOrders();
        dispatch(setB2BDrawerStep1(true));
        dispatch(setPaymentDrawer(false));
        setLoading(false);
      } else {
        enqueueSnackbar(
          Returntext(contentManagementData, 'ErrorMessages-settings', lang),
          { variant: 'error' },
        );
        setLoading(false);
      }
    } catch (error) {
      console.error('Error during transaction:', error);
      enqueueSnackbar(Returntext(contentManagementData, 'pmFail', lang), {
        variant: 'error',
      });
      setLoading(false);
    }
  };

  // new logic
  const payByCard = useSelector((state) => state.payByCard);
  // new logic

  return (
    <div className="payment-box">
      {loading && <PaymentLoader />}
      <div className="p-items">
        {!activeOrder.payed &&
          userData?.customerType?.toUpperCase() !== 'PERSONAL' && (
            <PaymentTypeSwitcher />
          )}
        {data && data.length > 0 && (
          <PriceItem2
            left={`${Returntext(
              contentManagementData,
              'air_freight_fee',
              lang,
            )} ${
              data[1][0]?.firstweightCost !== data[1][0]?.totalWeightCost
                ? '(-20%)'
                : ''
            }`}
            right={
              <div className="rc">
                {data[1][0]?.firstweightCost !==
                  data[1][0]?.totalWeightCost && (
                  <span className="lr">{`${data[1][0]?.firstweightCost}₾`}</span>
                )}
                <span className="gr">{`${data[1][0]?.totalWeightCost}₾`}</span>
              </div>
            }
          />
        )}
        <PriceItem
          left={Returntext(contentManagementData, 'PBTD', lang)}
          right={`${
            data !== undefined && data.length > 0
              ? data[1][0]?.delivery_fee
              : '0'
          }.00₾`}
        />
        {data && data.length > 0 && data[1][0]?.customFee > 0 && (
          <PriceItem
            left={Returntext(contentManagementData, 'PBTDS', lang)}
            right={`${
              data && data.length > 0 ? data[1][0]?.customFee : '0'
            }.00₾`}
          />
        )}
        {data && data.length > 0 && data[1][0]?.service_fee > 0 && (
          <PriceItem
            left={Returntext(contentManagementData, 'PBTDP', lang)}
            right={`${
              data && data.length > 0 ? data[1][0]?.service_fee : '0'
            }.00₾`}
          />
        )}
      </div>

      <div className="line"></div>

      {/* {data && data.length > 0 && (
        <PriceItem
          left={Returntext(contentManagementData, "discount", lang)}
          right={`${data[1][0]?.discountAmount}₾`}
        />
      )} */}

      <div className="total">
        <div className="left">
          {Returntext(contentManagementData, 'PBST', lang)}
        </div>
        <div className="right">
          {data !== undefined && data.length > 0
            ? data[1][0]?.totalPrice?.toFixed(2)
            : '0.00'}
          ₾
        </div>
      </div>

      {cardInfo === '' && payByCard && (
        <div className="info-warn">
          <WarnRecIcon className="icon" />
          <span className="txt" onClick={() => navigate('/wallet')}>
            {Returntext(contentManagementData, 'AddCardLink', lang)}
          </span>
        </div>
      )}

      {cardInfo !== '' && !activeOrder.payed && payByCard && (
        <CardDetails cardInfo={cardInfo} setCardInfo={setCardInfo} />
      )}

      {!activeOrder.payed && payByCard && (
        <BtnStandardIconText
          onClick={
            address === '' || cardInfo === '' || loading
              ? null
              : handleTransaction
          }
          mode=""
          txt={Returntext(contentManagementData, 'pay_btn', lang)}
          disabled={address === '' || cardInfo === '' || loading ? true : false}
          size={'lg'}
          icon={false}
          mainColor={'green'}
        />
      )}

      {!activeOrder.payed && !payByCard && (
        <BtnStandardIconText
          onClick={address === '' || loading ? null : handleTransactionB2B}
          mode=""
          txt={Returntext(contentManagementData, 'confirm_bank_payment', lang)}
          disabled={address === '' || loading ? true : false}
          size={'lg'}
          icon={false}
          mainColor={'black'}
        />
      )}
    </div>
  );
};

export default PaymentBox;
